import styled from 'styled-components';

export const CharterTimeContainer = styled.div`
 display: flex;
 flex-direction: column;
 align-items: center;
 justify-content: center;
 margin-top: 16px;
`;
